// Direction mapping for rack view
export const rackDirectionMapping = {
  S: "SOUTH",
  N: "NORTH",
  E: "EAST",
  W: "WEST",
};

export const UNIT_TYPES = {
  inch: "inch",
  feet: "feet",
};

//Unit_types prefix
export const UNIT_TYPES_PREFIX = {
  inch: "inch",
  feet: "ft",
};

export const colorsByObjectType = {
  rack: "#ddccaf",
  wall: "#d8b55b",
  area: "#f3f4f7",
  dock: "#c3c3c3",
};

//Organization types
export const ORGANIZATION_TYPES = {
  0: "CARRIER",
  1: "SHIPPER",
};

//change layoutTool Tab to selected element type
export const objectTypeMapping = {
  rack: "1",
  wall: "2",
  area: "3",
  zone: "4",
  dock: "5",
  yard: "6",
};
